<style>
.ivu-vueRadio {
    width: 100%;
    height: 100%;
}
.ivu-vueRadio-div {
    /* -webkit-transform:scale(0.8); */
    width: 100%;
    height: 100%;
    position: absolute;
    padding: 0;
}
.ivu-vueRadio-div .ivu-radio-input {
    opacity: 1;
}
.ivu-vueRadio-div .ivu-radio-inner {
    opacity: 0;
}
</style>

<template>
    <div class="ivu-vueRadio-div" v-if="isShow" :style="RadioStyle">
        <div v-for="(divSum, i) in segmentSum" v-bind:key="i" :style="divStyle">
            <RadioGroup
                v-model="picked"
                v-if="isverticaled"
                @on-change="changeModel"
                vertical
            >
                <Radio
                    v-for="(primitives, index) in data[divSum]"
                    :label="primitives + i + index"
                    :key="i + index"
                    :style="labelStyle"
                >
                    <span>{{ primitives }}</span>
                </Radio>
            </RadioGroup>

            <RadioGroup v-model="picked" v-else @on-change="changeModel">
                <Radio
                    v-for="(primitives, index) in data[divSum]"
                    :label="primitives + i + index"
                    :key="i + index"
                    :style="labelStyle"
                >
                    <span>{{ primitives }}</span>
                </Radio>
            </RadioGroup>
        </div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>

<script>
export default {
    name: "fvRadio",
    props: ["primitives", "fvSystemApi", "parentObject", "divSum"],
    created() {
        //窗口边框宽度。计算图元和组件位置时需要
        this.defaultTailoring = this.parentObject.defaultTailoring;
        //窗口大小
        this.windowSize = this.parentObject.windowSize;
        this.create();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath, {
            state: {
                $: this,
            },
        });
        this.data.splice(0);
        for (var i = 0; i < this.sourceData.length; i++) {
            var nColorRow = [];
            for (var j = 0; j < this.sourceData[i].length; j++) {
                var temptextValue = this.fvSystemApi.getResource(
                    this.sourceData[i][j]
                );
                if (temptextValue) {
                    nColorRow.push(temptextValue);
                } else {
                    nColorRow.push(this.sourceData[i][j]);
                }
            }
            this.data.push(nColorRow);
        }
        this.picked = this.data[0][0] + "00";
    },
    data() {
        return {
            isShow: true,
            isEnable: false,
            data: [],
            list: [], //复制data里的数据
            setData: [], //把list的二维数组转为一维数组
            sourceData: [],
            picked: "", //默认选中的值
            labelStyle: "",
            RadioStyle: "",
            divStyle: "",
            segmentSum: [], //创建数组在模板中循环判断创建外层div
            isverticaled: "",
            oldindex: "",
            newindex: "",
            tempindex: "",
        };
    },
    methods: {
        /**单选框 */
        create() {
            this.mixin(this.primitives);
            this.windowsObject = this.$parent.$parent;
            this.workbench = this.windowsObject.workbench;
            this.RadioStyle = {
                left: 0 + "px",
                top: 0 + "px",
                width: 0 + "px",
                height: 0 + "px",
                overflow: "hidden",
                fontSize: this.fontSize + "px",
                fontFamily: this.fontFamily,
                color: this.color,
            };

            this.enableStyle = {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0px",
                backgroundColor: "#ccbfbf",
                opacity: "0.5",
                zIndex: 1,
            };
            this.monitor();
            //是否竖直显示
            this.isverticaled = this.isVertical;
            //字体样式
            if (this.fontStyle) {
                this.RadioStyle.fontStyle = "oblique";
            }
            if (this.fontWeight) {
                this.RadioStyle.fontWeight = "bold";
            }

            if (this.isVertical) {
                //计算外层（div）数
                var temp = Math.ceil(this.content.length / this.oneListNum);
                for (var i = 0; i < temp; i++) {
                    this.segmentSum.push(i);
                    //每层div内文本内容
                    this.sourceData.push(
                        this.content.slice(
                            this.oneListNum * i,
                            this.oneListNum * (i + 1)
                        )
                    );
                }
                //设置宽度高度
                this.divStyle = {
                    width: this.width / temp + "px",
                    height: this.height + "px",
                    float: "left",
                };
                this.labelStyle = {
                    height: this.height / this.oneListNum + "px",
                    lineHeight: this.height / this.oneListNum + "px",
                    padding: 0,
                    fontSize: this.fontSize + "px",
                    color: this.color,
                };
            } else {
                var rowNum = Math.ceil(this.content.length / this.oneRowNum);
                for (var i = 0; i < rowNum; i++) {
                    this.segmentSum.push(i);
                    this.sourceData.push(
                        this.content.slice(
                            this.oneRowNum * i,
                            this.oneRowNum * (i + 1)
                        )
                    );
                }
                this.divStyle = {
                    width: this.width + "px",
                    height: this.height / rowNum + "px",
                    lineHeight: this.height / rowNum + "px",
                    float: "left",
                };
                this.labelStyle = {
                    width: this.width / this.oneRowNum + "px",
                    height: this.height / rowNum + "px",
                    float: "left",
                    margin: 0,
                    fontSize: this.fontSize + "px",
                    color: this.color,
                };
            }
            for (var i = 0; i < this.sourceData.length; i++) {
                var nColorRow = [];
                for (var j = 0; j < this.sourceData[i].length; j++) {
                    var temptextValue = this.fvSystemApi.getResource(
                        this.sourceData[i][j] + i + j
                    );
                    if (temptextValue) {
                        nColorRow.push(temptextValue);
                    } else {
                        nColorRow.push(this.sourceData[i][j] + i + j);
                    }
                }
                this.data.push(nColorRow);
                this.list.push(nColorRow);
            }
            for (var a = 0; a < this.list.length; a++) {
                for (var b = 0; b < this.list[a].length; b++) {
                    this.setData.push(this.list[a][b]);
                }
            }
        },
        //混入属性
        mixin(src) {
            for (var key in src) {
                this[key] = src[key];
            }
        },
        /*
            参数：无
            作用：选项状态发生改变时触发，提供控件click事件以及onchange事件
        */
        changeModel() {
            this.oldindex = this.newindex;
            if (this.tempindex != "") {
                this.oldindex = this.tempindex;
            }
            var val = this.picked;
            //查找制定元素在数组中的索引值
            Array.prototype.indexVf = function (arr) {
                // console.log(this);
                for (var i = 0; i < this.length; i++) {
                    var regex = new RegExp(this[i], "ig");
                    if (regex.exec(arr)) {
                        return i;
                    }
                }
            };
            // console.log(this.newindex);
            this.newindex = this.content.indexVf(val);
            this.tempindex = this.newindex;
            this.RegEvent_Click(this.newindex);
            this.RegEvent_Change(this.oldindex, this.newindex);
            if (typeof this.Change == "function") {
                this.fvSystemApi.executionScript(
                    this.Change,
                    this.oldindex,
                    this.newindex
                );
            }
            if (typeof this.Click == "function") {
                this.fvSystemApi.executionScript(this.Click, this.newindex);
            }
        },
        /*
            参数：无
            作用：获取当前单选中的文本
        */
        getValue() {
            return this.picked;
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e, domScale) {},
        reDraw(scaleObj) {
            // this.data.splice(0);
            // for(var i = 0; i < this.sourceData.length;i++){
            //     var nColorRow = [];
            //     for(var j = 0; j < this.sourceData[i].length;j++){
            //         var temptextValue = this.fvSystemApi.getResource(this.sourceData[i][j]);
            //         if(temptextValue){
            //             nColorRow.push(temptextValue);
            //         }else{
            //             nColorRow.push(this.sourceData[i][j]);
            //         }
            //     }
            //     this.data.push(nColorRow);
            // };
            // this.picked = this.data[0][0]+'00';

            // this.fontSize = (this.fontSize * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy;
            this.color = this.Color;
            this.RadioStyle.fontSize =
                12 * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy + "px";
            this.RadioStyle.left =
                parseInt(this.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) +
                "px";
            this.RadioStyle.top =
                parseInt(this.y * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) +
                "px";
            this.RadioStyle.width =
                parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.RadioStyle.height =
                parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            //判断是否是手机加载pc
            if (window.isApp() && scaleObj.isApp) {
                this.RadioStyle.width = parseInt(this.width) + "px";
                this.RadioStyle.height = parseInt(this.height) + "px";
            }
            var width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom));
            var height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom));
            if (this.isVertical) {
                //计算外层（div）数
                var temp = Math.ceil(this.content.length / this.oneListNum);
                //设置宽度高度
                this.divStyle = {
                    width: width / temp + "px",
                    height: height + "px",
                    float: "left",
                };
                this.labelStyle = {
                    height: height / this.oneListNum + "px",
                    lineHeight: height / this.oneListNum + "px",
                    padding: 0,
                    fontSize: this.fontSize + "px",
                    color: this.color,
                };
            } else {
                var rowNum = Math.ceil(this.content.length / this.oneRowNum);
                this.divStyle = {
                    width: width + "px",
                    height: height / rowNum + "px",
                    lineHeight: height / rowNum + "px",
                    float: "left",
                };
                this.labelStyle = {
                    width: width / this.oneRowNum + "px",
                    height: height / rowNum + "px",
                    float: "left",
                    margin: 0,
                    fontSize: this.fontSize + "px",
                    color: this.color,
                };
            }
        },
        onTimer() {
            if (this.isEnable) return;
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow) {
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable) {
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：当前下标
            作用：控件点击事件
        */
        RegEvent_Click(nIndex) {
            if (this.Click != "%Click%") {
                eval(this.Click);
            }
        },
        /*
            参数：选中前下标，当前下标
            作用：控件改变事件
        */
        RegEvent_Change(nOldSel, nNewSel) {
            if (this.Change != "%Change%") {
                eval(this.Change);
            }
        },

        monitor() {
            // 监听文本颜色
            Object.defineProperty(this, "Color", {
                set(value) {
                    var defaultColor = FColorToRGB.getColors();
                    var colorTemp = defaultColor[value];
                    var Color =
                        "RGB(" +
                        colorTemp[0] +
                        "," +
                        colorTemp[1] +
                        "," +
                        colorTemp[2] +
                        ")";
                    this.$forceUpdate();
                    this.$set(this.labelStyle, "color", Color);
                },
                get() {
                    return this.labelStyle.color;
                },
            });
            // 监听选中项的索引值
            Object.defineProperty(this, "State", {
                set(value) {
                    this.$forceUpdate();
                    this.picked = this.setData[value];
                },
                get() {
                    if (this.picked.length > 0) {
                        for (var i = 0; i < this.setData.length; i++) {
                            if (this.picked == this.setData[i]) {
                                var number = i;
                            }
                        }
                        return number;
                    } else {
                        return 0;
                    }
                },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/primitives/fvRadio/fvRadio.vue